import React, { Component } from "react"
import { Translate } from "../../components/translations"
import TriangleTwo from "../../images/triangle_two.png"
import TriangleThree from "../../images/triangle_three.png"
import { PageHeroProps } from "../../types"
import "./styles.scss"
import Counter from "../header/counter"

export class PageHero extends Component<PageHeroProps> {
  render() {
    const { title, subtitle, subtitle1, children, noPaddingBottom, countdown } = this.props
    // const cookiePadding = getCookiePolicy() === "registered" ? 'no-cookie' : 'with-cookie'
    
    return (
      <section id='seo_home_area' className={`seo_home_area ${noPaddingBottom ? 'noPaddingBottom' : ''}`}>
        <div className="home_bubble">
          <div className="bubble b_one" />
          <div className="bubble b_two" />
          <div className="bubble b_three" />
          <div className="bubble b_four" />
          <div className="bubble b_five" />
          <div className="bubble b_six" />
          <div className="triangle b_eight">
            <img src={TriangleTwo} alt="" />
          </div>
          <div className="triangle b_nine">
            <img src={TriangleThree} alt="" />
          </div>
        </div>
        <div className="container">
          <div className="breadcrumb_content text-center">
            {title && (
              <h1 className="page-hero-title">
                {typeof title === "string" ? <Translate name={title} /> : title}
              </h1>
            )}
            {subtitle && (
              <p className="f_300 page-hero-subTitle">
                {typeof subtitle === "string" ? (
                  <Translate name={subtitle} />
                ) : (
                  subtitle
                )}
              </p>
            )}
            {subtitle1 && (
              <p className="f_300 page-hero-subTitle">
                {typeof subtitle1 === "string" ? (
                  <Translate name={subtitle1} />
                ) : (
                  subtitle1
                )}
              </p>
            )}
            {countdown && <Counter date='Dec 26 2022 07:00:00 GMT' />}
            {children}
          </div>
        </div>
      </section>
    )
  }
}
